import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-logo',
  template: `<svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="220px"
    viewBox="0 0 1396 252"
    style="enable-background:new 0 0 1396 252;"
    xml:space="preserve"
  >
    <style type="text/css">
      .st0 {
        fill: #222222;
      }
      .st1 {
        fill: #fa4c65;
      }
    </style>
    <g>
      <path
        class="st0"
        d="M745.7,54.4c-13.2,0-26.3-0.1-39.5,0.1c-4.6,0.1-6.2-1.6-6.1-6.1c0.2-6.7,0.3-13.3,0-20
		c-0.2-3.8,1.6-5.1,4.9-5.1c3,0,6,0,9,0c26.8,0.2,53.6-0.6,80.4,0.8c9.5,0.5,16,5.9,22.1,12.7c7.2,7.9,9.7,16.9,9.6,27.2
		c-0.1,5.7-2.3,10.7-4.5,15.6c-1.5,3.3-1.5,6,0.1,9.4c8,16.9,5.5,32.8-7.6,45.4c-5.6,5.4-12.6,9.2-20.7,10
		c-19.4,2-38.9,0.4-58.3,0.5c-9.1,0-18.3-0.4-27.4,0.4c-6.3,0.6-7.5-0.9-7.4-7.2c0.1-5.5,0.1-11,0-16.5c-0.2-7.4,0.1-7.7,7.3-7.7
		c25.8,0,51.7,0,77.5,0c7.1,0,10.6-4.4,8.1-9.9c-0.9-2-2.3-3.2-4.4-3.5c-3-0.4-5.9-0.9-8.9-0.9c-21.5-0.1-43,0-64.5-0.1
		c-3.6,0-7.2,0.9-10.9,0.3c-3.1-0.5-4.3-1.9-4.2-5c0.1-7,0.1-14,0-21c-0.1-3.7,1.5-5.1,5.1-5c9.2,0.1,18.3,0,27.5,0c17,0,34,0,51,0
		c3.6,0,7.2-0.5,9.1-3.8c3.1-5.2-0.5-10.5-7.2-10.5C772.3,54.3,759,54.4,745.7,54.4z"
      />
      <path
        class="st0"
        d="M1325.2,54.4c-10.5,0-21,0.1-31.5,0c-4.6-0.1-7.4,2-8.3,6.2c-0.9,4.6,2.5,6.5,6.2,7.5c1.9,0.5,3.9,0.6,5.9,0.6
		c13.7,0,27.3-0.1,41,0c17.8,0.2,31.2,10.7,35.9,25.7c6.7,21.4-3.9,42-25.1,49c-7.5,2.5-15.5,1.9-23.2,1.6
		c-16.5-0.6-32.9,0.7-49.4,0.2c-4.5-0.1-9-0.1-13.5,0c-3.9,0.1-5.8-1.2-5.7-5.4c0.2-6.8,0.2-13.6,0-20.4c-0.1-4.5,1.8-5.7,6-5.7
		c24,0.1,48,0.1,72,0.1c6.7,0,10.7-4.9,8.1-10.1c-1.9-3.8-5.5-4.3-9.4-4.3c-14.7,0-29.3,0-44,0c-16.9,0-31.9-11.5-35.9-27.8
		c-6.4-25.6,12.4-48.4,37-48.2c21.3,0.2,42.6,0.2,63.8-0.2c6.6-0.1,6.8,0.2,6.8,6.6c0,6.2-0.2,12.3,0.1,18.5c0.2,4.5-1.4,6.3-6,6.2
		C1345.8,54.2,1335.5,54.4,1325.2,54.4z"
      />
      <path
        class="st1"
        d="M24.1,84c0-18,0-36,0-53.9c0-5.7,1.2-7.1,7-7.1c6.6,0,13.3,0.5,19.9,0.5c11,0,22-0.7,32.9-0.5
		c12.5,0.3,25.2,0.2,37,5.8c21.4,10.2,34.9,26,36.4,50.3c1.3,19.8,0.1,39.6,0.6,59.4c0.1,4.5-2.1,6.8-6.7,6.7
		c-6.8,0-13.6-0.2-20.4,0c-3.7,0.1-5.2-1.7-5.4-4.9c-0.2-3.2-0.2-6.3-0.1-9.5c0.1-15-0.1-29.9,0.5-44.9
		c0.7-17.9-11.6-29.8-29.5-30.6c-10.8-0.5-21.6-0.4-32.5-0.4c-6.4,0-7.1,0.9-7.1,7.2c0,24.6,0,49.3,0,73.9c0,8.2-0.8,9-9.1,9
		c-5.7,0-11.3,0-17,0c-5.7,0-6.5-0.9-6.5-6.8C24.1,120.3,24.1,102.2,24.1,84z"
      />
      <path
        class="st0"
        d="M989.9,83.8c0-18.1,0.1-36.3-0.1-54.4c0-4.3,1.5-6.3,5.7-6.1c24.8,0.7,49.6-1.3,74.3,1.1
		c19.7,1.9,43.2,17.5,50.1,39.2c2.2,6.7,3.2,13.5,3.2,20.5c0,18.3-0.1,36.6,0.1,54.9c0.1,4.8-1.7,6.6-6.4,6.4
		c-6.8-0.2-13.7-0.2-20.5,0c-3.8,0.1-5.3-1.2-5.2-5.2c0.2-17.5,0-35,0.1-52.4c0-4.7-0.5-9.3-1.9-13.7c-3.6-11.4-12.3-17.2-23.5-18.3
		c-12.7-1.2-25.6-0.8-38.4-1.3c-4.2-0.1-5.9,2-5.8,5.7c0.3,23.3-0.8,46.6,0.5,69.8c0.9,15,0.8,15.3-14,15.3c-4,0-8-0.2-12,0.1
		c-4.6,0.3-6.2-1.6-6.2-6.1C990,120.7,989.9,102.3,989.9,83.8z"
      />
      <path
        class="st0"
        d="M1163.8,54.4c-8.7,0-17.3-0.2-26,0.1c-4.2,0.1-5.6-1.6-5.5-5.6c0.2-6.8,0.2-13.5,0-20.3
		c-0.1-3.6,1.4-5.5,4.9-5.3c12.5,0.8,24.9-0.3,37.4,0c7.5,0.2,15,0.5,22.4,0.7c14.7,0.4,25.4,7.9,34.9,18.3
		c10.6,11.6,15.7,25.3,15.7,40.6c0,14.5-3.4,28.1-13.2,39.8c-8.3,10-17.7,17.8-30.5,20.8c-5,1.1-10.2,1.7-15.3,1.7
		c-16.4,0.1-32.8-0.7-49.2,0c-5.9,0.3-7-1.1-7.1-6.9c0-6.1,0.1-12.2-0.1-18.3c-0.1-4.4,1.6-6.3,6.2-6.3c16,0.1,32,0.1,48,0
		c2.3,0,4.7,0,6.9-0.6c15.4-3.9,23.8-16.3,21.9-32.5c-2.1-17.1-13.2-27.4-29.4-26.4c-6.3,0.4-12.7,0-19,0c-1,0-2,0-3,0
		C1163.8,54.3,1163.8,54.4,1163.8,54.4z"
      />
      <path
        class="st1"
        d="M350,54.5c-7.5,0-15,0.4-22.5-0.1c-19.4-1.2-31.1,17.3-28,34.5c2.1,11.6,7.8,20.6,20,24.2
		c2.3,0.7,4.6,0.8,6.9,0.8c16.5,0,33,0,49.5,0c6.2,0,6.3,0.1,6.3,6.5c0,6.3-0.2,12.7,0.1,19c0.1,4-1.6,6-5.5,5.9
		c-20.8-0.4-41.6,0.9-62.3-1.2c-12.4-1.2-22.6-8-31.1-17.1c-25.1-26.5-21.6-72.4,9.8-94.4c9.1-6.3,19-8,29.2-9
		c17.4-1.6,34.9-0.5,52.4-0.7c6.2-0.1,7.2,1.1,7.3,7.2c0,5.8,0,11.7,0,17.5c0,5.9-0.8,6.7-6.6,6.8C367,54.5,358.5,54.5,350,54.5z"
      />
      <path
        class="st1"
        d="M511.6,99.5c0,12.3,0,24.6,0,37c0,7.9-1.8,9.3-9.5,8.5c-4.9-0.5-10-0.4-14.9,0c-6.4,0.5-8.2-0.7-8.2-7.1
		c0.1-24.5,0.2-48.9,0.3-73.4c0-1.5,0-3-0.1-4.5c-0.3-3.9-2.2-5.8-6.5-5.7c-9.8,0.3-19.7,0.1-29.5,0.3c-4.1,0.1-5.7-1.5-5.6-5.6
		c0.2-6.5,0.3-13,0-19.5c-0.3-5.1,2.2-6.5,6.5-6.4c6.1,0.1,12.3,0.6,18.4,0.5c13.8-0.1,27.6-0.8,41.4-0.4
		c13.8,0.4,27.6-0.1,41.4-0.1c6.9,0,7.9,1.1,7.4,7.9c-0.5,5.5-0.3,11,0,16.4c0.3,5.9-0.9,7.1-6.7,7.1c-9.3,0-18.7,0-28-0.1
		c-5.4,0-6.8,1.1-6.8,6.7c-0.1,12.8,0,25.7,0,38.5C511.4,99.5,511.5,99.5,511.6,99.5z"
      />
      <path
        class="st1"
        d="M610,118.9c-0.3-31.6,2.7-21.5-15.6-46c-11.2-15-22.8-29.7-34.2-44.5c-1-1.3-2.1-2.8-1.4-4.4
		c0.7-1.7,2.7-1.1,4.1-1c8.1,0.7,16.3,0.7,24.4,0c3.8-0.4,6.7,1.2,9,4.3c7.9,10.6,16.8,20.5,24.4,31.4c4.2,5.9,7,5.7,12-0.5
		c7.7-9.6,15.6-19,22.8-28.9c4-5.5,9.1-6.8,15.2-6.1c6.1,0.7,12.3,0.6,18.4,0.1c1.6-0.1,3.6-1.2,4.6,0.6c1.1,2,0.5,4.1-1,6
		c-4,5-7.9,10-11.8,15.1c-7.5,9.8-15,19.6-22.5,29.3c-3.9,5.1-8.2,9.9-12,15.1c-2.3,3.1-2.9,6.8-2.9,10.7c0,12.7,0,25.3,0,38
		c0,6.2-1.1,7.3-7.1,7.4c-6.3,0-12.7,0-19,0c-5.9,0-7.2-1.3-7.2-7.4C610,131.6,610,125.2,610,118.9z"
      />
      <path
        class="st1"
        d="M196.2,118.7c-0.5-7.3,0.9-15.9-1.1-24.5c-1.4-6-4-11.2-8.3-15.6c-14.8-15.1-26.6-32.6-39.7-49
		c-1.1-1.4-2-3.2-0.9-5.1c0.9-1.5,2.5-1.1,4.1-1.1c6.1-0.1,12.3-0.1,18.4-0.6c8-0.7,14,1.7,18.4,8.7c5.6,8.9,12.5,16.9,19.1,25
		c5.2,6.5,6.8,6.6,12,0.2c8-9.9,16.1-19.7,24.1-29.7c2.5-3.2,6-4.7,9.6-4.1c8,1.2,15.9-0.8,23.9,0.1c1.6,0.2,3.5-0.7,4.5,1.2
		c0.9,1.9-0.6,3.2-1.5,4.4c-7.3,9.3-14.7,18.4-22,27.6c-8.5,10.8-17,21.6-25.5,32.4c-1.7,2.2-2.1,4.8-2.1,7.5
		c0,13.7-0.1,27.3-0.1,41c0,6.6-1.6,8.3-8.3,7.8c-6-0.5-12-0.4-18,0c-5.1,0.3-6.7-1-6.7-6.1C196.1,132.7,196.2,126.4,196.2,118.7z"
      />
      <path
        class="st0"
        d="M835,84.1c0-18.1,0-36.3,0-54.4c0-5.4,1.4-6.8,6.8-6.3c6.5,0.6,12.9,0.6,19.4,0c4-0.4,6.4,1,6.3,5.4
		c-0.3,21.5,0.5,42.9-0.4,64.4c-0.2,5-0.1,10,0,15c0.1,4.3,2.3,6.2,6.6,6.1c18.1-0.2,36.3-0.1,54.4-0.3c4.4-0.1,6.3,1.3,6.1,6
		c-0.4,6.5-0.4,13,0,19.5c0.3,5.1-1.9,6.2-6.4,6.1c-14.5-0.3-28.9-0.5-43.4-0.5c-14.1,0-28.3,0.3-42.4,0.4c-6.3,0-7-0.7-7-6.8
		C835,120.4,835,102.2,835,84.1z"
      />
      <path
        class="st0"
        d="M944.7,84.4c0-18.3,0.1-36.6-0.1-54.9c0-5,0-6.7,6.6-6.3c6.5,0.4,12.9,0.6,19.4-0.1c3.8-0.4,6.2,0.8,6.1,5.5
		c-0.3,18-0.4,35.9-0.4,53.9c0,18.4,0.2,36.9,0.3,55.3c0,7-1.2,7.9-8.3,7.2c-5.5-0.6-10.9-0.6-16.4,0.1c-6.2,0.8-7.3-0.3-7.3-6.4
		C944.7,120.7,944.7,102.6,944.7,84.4z"
      />
      <path
        class="st1"
        d="M426,84.3c0,18.3,0,36.6,0,54.9c0,5.1-1.4,6.4-6.6,6c-6-0.5-11.9-0.4-17.9,0c-5.9,0.4-7.6-1.2-7.6-6.9
		c0-36.3,0.1-72.6-0.1-108.8c0-4.4,1.3-5.8,5.6-5.7c6.8,0.1,13.6-0.1,20.4-0.4c4.4-0.2,6.3,1.2,6.2,6C425.9,47.7,426,66,426,84.3z"
      />
      <path
        class="st0"
        d="M167.9,214.3c1.6-8,3.2-15.9,4.6-23.9c1-5.7,5.4-2.7,8-2.8c3.4-0.1,0.9,2.7,0.6,3.9
		c-2.7,11.3-5.8,22.5-8.4,33.8c-0.7,3-2.1,3.8-4.7,3.3c-2.6-0.4-6,1.7-7-3.1c-1.7-8.1-3.9-16-6.7-24.1c-2.1,7.9-4.5,15.7-6,23.7
		c-0.9,4.8-4,3.3-6.7,3.5c-2.6,0.2-5,0.6-5.8-3.4c-2.5-11.1-5.6-22.2-8.3-33.3c-0.3-1.3-2.3-4.3,0.5-4.3c2.8,0,7.4-3.1,8.7,2.4
		c2.1,9.2,3.9,18.5,5.8,28.1c2.4-9.3,5-18.2,6.9-27.2c1.1-5,4.5-3.1,7.3-3.5c2.8-0.5,3.4,1.1,4.2,3.5c2,6.2,2.4,12.7,4.3,18.9
		l0.5,1.9l0.8,2.4l0.9,2.7L167.9,214.3z"
      />
      <path
        class="st0"
        d="M705.7,206c4.9,0.4,6.1,4.8,9.6,6.8c3.5-3.4,4.7-7.8,4.1-12.4c-0.4-3.3,1.1-3.1,3.4-3.2
		c2.9-0.2,4.9,0.2,4.7,3.7c-0.4,7-2.9,13.1-8.1,18c2.1,2.2,4.2,3.8,7.4,3.4c1.2-0.2,3.1-2.9,3.6,0.5c0.3,2.4,0.6,5.1-3,5.7
		c-4.3,0.7-8.5,0.1-11.7-2.8c-1.7-1.6-2.4-1.1-4-0.2c-6.3,3.3-13,4.3-20,2c-5.1-1.7-7.4-5.5-7.8-10.4c-0.4-4.8,2.4-8.1,6.5-10.2
		c1.9-0.9,3.3-1.4,1.3-3.7c-3.2-3.6-4.4-7.4-1.1-11.6c2.7-3.4,10.5-5.5,14.6-3.6c3.2,1.5,6.9,2.6,7.4,7.1
		C713,198.9,711.8,201.2,705.7,206z M701.4,222.2c2.5-0.3,6-1.4,8.1-4.4c0.9-1.3-7.6-8.4-10.2-8.6c-2.8-0.2-6.1,3.2-6.2,6.5
		C693.1,219.7,695.8,222.2,701.4,222.2z M704.6,199c-0.1-3.5-1-4.6-3.3-4.7c-2.8-0.1-4.2,1.7-4.1,3.7c0.1,1.6,1.4,4.2,3.6,4
		C702.8,201.8,704.6,200.3,704.6,199z"
      />
      <path
        class="st0"
        d="M1056.4,213.8c0-2.8-0.2-5.7,0.1-8.5c0.2-2.1-1.5-5.5,1.5-5.8c2.4-0.3,6.3-2.6,7.8,2.2
		c0.5,1.7,1.9,0.4,2.8-0.1c6.6-3.6,8.1-3.7,13,1.3c1.8,1.9,2.3,0.2,2.9-0.4c3.3-3.1,7.1-4.6,11.3-2.6c4.6,2.1,6,6.2,5.8,11.1
		c-0.2,4.8-0.2,9.7,0,14.5c0.2,5.4-3.9,2.5-6,3.2c-3,0.9-3.1-1-3-3.3c0.1-4.2,0-8.3,0-12.5c0-3.1-0.4-6.4-4.4-6.4
		c-3.9,0-4.4,3.6-4.7,6.4c-0.4,4.3-0.3,8.7,0.1,13c0.3,3.4-1.8,3.1-3.7,2.8c-2-0.3-5.5,2.1-5.5-2.6c0-4.7,0-9.3,0-14
		c0-2.8-0.3-5.7-4-5.6c-3.4,0-4.9,2.4-4.8,5.7c0,4.5,0,9,0.1,13.5c0.1,5.3-4,2.3-6.2,3.1c-2.5,0.9-3.1-0.7-3.1-2.9
		C1056.5,221.8,1056.4,217.8,1056.4,213.8z"
      />
      <path
        class="st0"
        d="M776.4,203.2c0-3.6,0-6.9,0-10.2c0-5.4,2.3-7,7.6-5.7c1.9,0.5,1.6,1.8,1.6,3.1c0,11.8,0,23.6,0,35.5
		c0,4.7-3.4,2.3-5.4,2.7c-1.9,0.4-4.2,0.7-3.7-2.7c0.2-1.1,0.1-2.3-0.1-3.5c-0.4-3.6,1.6-9.1-0.9-10.3c-3.6-1.8-8.7-0.6-13.2-0.7
		c-2,0-1.9,1.3-1.8,2.7c0.1,3,0,6,0,9c0,5.5-2,6.9-7.5,5.8c-2-0.4-1.7-1.7-1.7-3c0-11.8,0.1-23.6-0.1-35.5c0-3.1,1.6-3.3,3.7-2.9
		c2,0.4,5.4-2,5.6,2.5c0,0.2,0,0.3,0,0.5c0,4.1-0.1,8.3,0,12.4c0,0.1,0.6,0.3,0.9,0.3C766.5,203.2,771.5,203.2,776.4,203.2z"
      />
      <path
        class="st0"
        d="M515.2,203.3c8.2-5.5,8.4-5.6,16.2,0c1.3,0.9,1.4,0.4,2.2-0.4c3.1-3,7-5,11.2-3.2c4.8,2,6.3,6.3,6,11.4
		c-0.2,4.3-0.5,8.7,0.1,13c0.6,4.6-1.9,4.3-5.1,4.6c-4.6,0.5-3.8-2.2-3.7-4.8c0-4,0.1-8,0-12c0-2.9-0.9-5.3-4.3-5.6
		c-3.4-0.3-4.3,2.5-4.5,4.9c-0.4,4.8-0.3,9.6-0.1,14.4c0.1,5-3.6,2.4-5.7,2.9c-2,0.5-3.8,0.5-3.6-2.8c0.3-4.6,0.1-9.3,0-14
		c-0.1-2.5-0.3-5.4-3.7-5.4c-3.4-0.1-5.1,2.3-5.3,5.4c-0.2,4.5-0.3,9,0,13.5c0.4,5.3-3.5,2.8-5.7,3.3c-3.1,0.7-3.5-0.9-3.4-3.6
		c0.1-7.1-0.1-14.3-0.1-21.5c0-1.7-1.2-4.1,2.3-4.4C513.1,198.6,514.2,199,515.2,203.3z"
      />
      <path
        class="st0"
        d="M837.1,203.8c7.3-6.2,9.6-6.3,16.7-0.6c1.5,1.2,1.2,0.2,1.8-0.4c3.3-3.1,7.3-4.9,11.7-3.1
		c4.4,1.8,5.5,5.8,5.5,10.3c-0.1,4.7-0.2,9.3,0.2,14c0.3,3.6-0.5,4.8-4.4,4.8c-3.8,0-4.9-0.9-4.6-4.7c0.4-4.1,0.3-8.3,0-12.5
		c-0.2-2.3-0.3-5.2-3.9-5.3c-3.5,0-4.7,2.4-4.9,5.1c-0.3,4.5-0.5,9-0.1,13.5c0.5,5.2-3,3.3-5.4,3.7c-3,0.5-3.7-0.7-3.5-3.5
		c0.3-4.3,0.2-8.6,0.1-13c0-2.9-0.8-5.3-4.1-5.8c-3.7-0.5-4.8,2.4-5,5c-0.4,4.4-0.5,9,0,13.4c0.6,5.1-2.8,3.5-5.3,3.9
		c-3.3,0.5-4.2-0.7-4.1-4.1c0.2-7.1,0.3-14.3-0.2-21.4c-0.2-3.7,1.3-4,4.2-4C837.2,199.3,837.2,199.1,837.1,203.8z"
      />
      <path
        class="st0"
        d="M922.7,228.1c3.9-11.5,7.8-22.7,11.6-34c2.1-6.4,5.4-8.3,11.7-6.7c2.1,0.5,2.5,2.4,3.1,4.1
		c3.8,11.4,7.6,22.9,11.6,34.3c0.8,2.3,0.2,2.8-2,2.8c-4.4,0.2-8.9,0.7-8.8-5.9c0-1-0.8-1.9-1.9-2c-4,0-8,0-12,0.1
		c-1,0-1.5,0.7-2,1.8C931.3,229.4,931.1,229.4,922.7,228.1z M941.1,197.7c0,3.6-1.5,5.8-2.3,8.3c-2.4,7.5-1.4,8.6,6.4,7.1
		c1.1-0.2,2.1-0.4,1.5-1.7C944.8,207.1,945.1,202.2,941.1,197.7z"
      />
      <path
        class="st0"
        d="M316.9,220.4c1.3-5.8,2.9-11.5,3.9-17.4c0.6-3.5,2.5-3.9,5.5-3.9c2.9,0,4.7,0.6,5.2,3.8
		c0.9,5.7,2.1,11.4,4.1,17.2c1-5.7,1.9-11.4,3-17.1c0.6-3.2,5.7-5.3,8.4-3.6c1.2,0.8,0.5,1.7,0.3,2.6c-2.2,7.6-4.7,15.2-6.4,22.9
		c-1.1,4.8-4.3,3.4-7.2,3.8c-3,0.4-4.1-0.8-4.5-3.7c-0.7-4.6-1.8-9-3.8-13.7c-1.3,4.5-2.6,9.1-3.9,13.6c-0.6,2.1-0.6,4.3-3.9,3.8
		c-2.9-0.5-6.1,1.2-7.2-3.7c-1.6-7.3-4.1-14.4-5.9-21.6c-0.3-1.2-2.6-4.1,0.9-4c2.4,0.1,6.3-2.5,7.5,2.1
		C314.3,207.8,315.6,214.1,316.9,220.4z"
      />
      <path
        class="st0"
        d="M255.9,202c0-4.3,0.2-8.6-0.1-12.9c-0.3-3.8,2.3-3.1,4.2-2.8c1.8,0.2,5-1.9,4.9,2.6c-0.1,12.3-0.1,24.6-0.1,37
		c0,1.1,0.5,2.7-1.3,2.6c-2.6-0.1-5.8,1.5-7.5-0.9c-1.1-1.6-1.2-1.3-2.7-0.7c-6.7,2.7-11.9,2-15.1-1.7c-3.8-4.5-4.6-12.4-1.9-17.8
		C240.9,198.7,245.3,197.5,255.9,202z M256,213.9c0-3.9-0.5-7.4-5.5-7.6c-3.5-0.1-6.6,3.4-6.8,7.5c-0.1,4,2.9,8.3,6,8.4
		C253.6,222.3,255.9,219.2,256,213.9z"
      />
      <path
        class="st0"
        d="M202.3,213.9c0-3.5-0.1-7,0-10.5c0-1.5-1.2-3.9,1.3-4.1c2.6-0.1,6.5-1.9,7.6,1.2c1.3,3.5,2.4,1.2,3.2,0.5
		c6.2-4.8,15.5-0.9,15.3,8.7c-0.1,5.2-0.2,10.3,0.1,15.5c0.3,4.4-2.7,3.1-4.9,3.3c-2.3,0.2-4.1,0.3-3.9-3.2c0.3-4.6,0.1-9.3,0-14
		c-0.1-2.9-1.2-5.2-4.7-5.2c-3.8,0-4.7,2.7-4.8,5.7c-0.2,4.6-0.1,9.3,0.1,14c0.1,4.3-3,2.5-4.9,2.6c-1.8,0.1-4.6,1.3-4.4-2.6
		C202.5,221.9,202.3,217.9,202.3,213.9C202.3,213.9,202.3,213.9,202.3,213.9z"
      />
      <path
        class="st0"
        d="M1211.2,213.8c0-3.2-0.2-6.3,0.1-9.5c0.1-1.7-1.4-4.8,1.5-4.9c2.5-0.1,6.1-2.4,7.7,1.9
		c0.8,2.2,1.8,0.5,2.5,0.1c10.1-4.8,15.5-1.3,15.6,10c0,4.3-0.2,8.7,0.1,13c0.3,3.7-1.2,4.3-4.5,4.4c-3.6,0.1-4.5-1-4.3-4.4
		c0.3-4,0.2-8,0-12c-0.1-3.1-0.6-6.2-4.9-6.1c-4,0.2-4.7,3-4.7,6.2c0,4.2-0.2,8.3,0.2,12.5c0.5,4.8-2.7,3.3-5.1,3.5
		c-2.4,0.2-4.6,0.6-4.2-3.3C1211.6,221.5,1211.3,217.7,1211.2,213.8C1211.3,213.8,1211.2,213.8,1211.2,213.8z"
      />
      <path
        class="st0"
        d="M992.7,214.2c0,2.8,0.2,5.7-0.1,8.5c-0.2,2,1.5,5.5-0.9,5.7c-2.5,0.2-6.2,2.6-8.3-1.5
		c-0.9-1.9-1.9,0.1-2.7,0.4c-10.1,4.2-15.8-0.9-15.4-10.6c0.2-4.7,0.3-9.3-0.1-14c-0.3-3.9,2-3.4,4.4-3.4c2.2,0,4.7-0.7,4.4,3.2
		c-0.3,4.8-0.2,9.7,0.1,14.5c0.1,2.7,0.8,5.4,4.6,5.3c3.4-0.1,4.7-2.4,4.8-5.3c0.2-4.8,0.3-9.7,0-14.5c-0.2-3.4,1.6-3.6,4-3.2
		c2.1,0.3,5.4-1.6,5.3,2.9C992.6,206.2,992.7,210.2,992.7,214.2C992.7,214.2,992.7,214.2,992.7,214.2z"
      />
      <path
        class="st0"
        d="M587.9,213.9c0-3.7-0.1-7.3,0-11c0-1.4-1-3.9,1.8-3.6c2.3,0.2,5.8-2.1,6.9,1.6c1,3.4,2,1.4,3.3,0.6
		c7.8-4.7,14.2-2.1,15.4,7c0.8,5.9,0.7,12,0.3,17.9c-0.3,4.4-4.2,1.5-6.4,2.2c-2.4,0.8-2.5-0.9-2.5-2.9c0.1-4.5,0.2-9-0.1-13.5
		c-0.2-2.8-0.6-6-4.5-5.9c-3.9,0.1-5.4,2.6-5.4,6.3c0,4-0.3,8,0.1,12c0.5,4.7-2.5,3.8-5.2,4.1c-3.2,0.4-4-0.8-3.8-3.8
		C588.1,221.3,587.9,217.6,587.9,213.9z"
      />
      <path
        class="st0"
        d="M385.1,211.8c0,4.2-0.5,8.4,0.1,12.4c0.8,5.5-2.8,4.1-5.7,4.5c-4.3,0.6-3.9-1.9-3.9-4.7
		c0.1-8.3-0.2-16.6,0.1-24.9c0.1-3.2-0.8-4.3-3.8-3.8c-1,0.2-2-0.1-3,0.2c-2.9,0.6-4.6,0.4-4.4-3.4c0.1-3.3,0.2-5.1,4.4-4.9
		c8,0.4,16,0.3,23.9-0.1c5-0.2,3.4,3.1,3.8,5.6c0.5,3.4-1.8,2.7-3.7,2.7c-7.7-0.1-7.7,0-7.6,7.4
		C385.1,205.8,385.1,208.8,385.1,211.8z"
      />
      <path
        class="st0"
        d="M476.7,217.6c0,2.2,0.2,4.3-0.1,6.5c-0.2,1.5,1.4,4.3-1.4,4.4c-2.2,0-5.7,2.4-7-1.9c-0.3-0.9-0.5-0.9-3.6,0.8
		c-4.5,2.5-10.3,1.5-12.5-2c-2.4-3.9-1.3-10.3,2.7-12.9c3.1-2,6.8-2.2,10.4-2.2c1.1,0,2.9,0.9,2.9-1.4c0-1.7-1.4-2.2-2.7-2.3
		c-2.8-0.2-5.5-0.3-8.3,0.7c-1,0.4-2.9,2.4-3.7,0c-0.5-1.7-1.2-4.4,1.1-5.4c4.7-2.1,9.5-3.9,14.7-1.8c5,2,7.7,5.5,7.2,11.1
		C476.6,213.2,476.7,215.4,476.7,217.6z M465.1,215.4c-2.9-0.5-5.3,0.4-5.7,3.3c-0.3,1.9,1.1,3.7,3.7,3.5c3.2-0.2,4.8-2.1,5.3-4.9
		C468.9,214.4,466.4,215.7,465.1,215.4z"
      />
      <path
        class="st0"
        d="M792.4,214.3c0-9.5,5.5-15,15.1-15.1c8.9,0,15.1,5.7,15.2,14.1c0.1,10-5.4,15.3-15.8,15.3
		C797.5,228.6,792.4,223.6,792.4,214.3z M813.9,214.4c0.1-5.5-2-8.1-6.4-8.1c-4.2,0.1-6.2,2.5-6.3,7.7c-0.1,5.1,2.3,8.2,6.4,8.2
		C811.5,222.2,813.8,219.4,813.9,214.4z"
      />
      <path
        class="st0"
        d="M285.5,228.6c-9.5,0-15-5.3-15-14.6c0-8.9,6.3-14.8,15.7-14.8c8.9,0,14.5,5.4,14.6,14.1
		C300.9,223.4,295.7,228.6,285.5,228.6z M292.1,213.9c-0.1-5.5-1.7-7.6-6.1-7.6c-4.3,0-6.9,3.2-6.8,8.3c0.1,4.4,2.9,7.6,6.6,7.5
		C289.9,222.1,292.2,219.2,292.1,213.9z"
      />
      <path
        class="st0"
        d="M1175.4,213.8c0-9.2,5.9-14.7,15.6-14.6c8.5,0.1,14.6,6,14.7,14.1c0,10-5.4,15.3-15.8,15.3
		C1180.4,228.7,1175.4,223.5,1175.4,213.8z M1196.9,214c-0.1-5.2-2.1-7.6-6.3-7.7c-4.4,0-6.6,2.6-6.7,7.8c0,4.9,2.5,8,6.6,8
		C1194.7,222.2,1196.9,219.3,1196.9,214z"
      />
      <path
        class="st0"
        d="M1035.5,228.5c-9.2,0.1-15-5.2-15.1-13.9c-0.1-8.9,6.1-15.3,15.2-15.3c10.7-0.1,15.6,6.6,15.9,14.5
		C1051.7,222.9,1045.5,228.3,1035.5,228.5z M1042.2,214.4c0-5.6-1.9-8-6.3-8c-4.1,0-6.6,3-6.7,7.9c-0.1,4.3,2.7,7.8,6.2,7.9
		C1039.6,222.3,1042.2,219.3,1042.2,214.4z"
      />
      <path
        class="st0"
        d="M1123.1,225.2c-1.8,1-3.1,2.1-4.6,2.7c-3.7,1.6-7.3,1.1-10.2-1.5c-3-2.6-2.6-6.5-1.6-9.8
		c0.9-3,3.1-5.3,6.9-5.5c2.5-0.1,4.8-1.2,7.4-1c1,0.1,2.5,0.4,2.4-1.5c-0.1-1.4-1-2.2-2.2-2.2c-3-0.2-5.9-0.4-8.8,0.7
		c-0.9,0.3-2.9,2-3.2-0.1c-0.3-1.6-1.7-4.2,0.8-5.4c4.5-2.2,9.4-3.7,14.3-1.9c5,1.8,7.9,5.2,7.5,10.9c-0.2,4.5,0.2,9-0.2,13.5
		c-0.1,1.4,2.1,4.6-1.6,4.4C1127.3,228.3,1123,231.3,1123.1,225.2z M1120.3,215.5c-3.5-0.6-5.8,0.4-6,3.4c-0.1,2,1.4,3.6,4,3.3
		c3.1-0.3,4.8-2.2,5-5.1C1123.5,214.1,1121,215.8,1120.3,215.5z"
      />
      <path
        class="st0"
        d="M895.8,216.8c-1.7,0-3.3-0.1-5,0c-1.2,0.1-3.2-0.9-3.5,0.7c-0.3,1.5,0.9,2.9,2.6,3.7c3.2,1.5,6.5,1.1,9.7,0.4
		c1.2-0.3,2.7-1.8,2.9,0.3c0.2,1.6,1.3,4-1.2,5.3c-5,2.6-16.1,1.3-19.8-2.2c-3.7-3.6-4.7-12.5-2-18.4c2.3-5,10.7-8.8,16.1-7.3
		c6.4,1.8,10.5,8.8,9.4,15.7c-0.2,1.6-0.9,1.9-2.2,1.9c-2.3,0-4.7,0-7,0C895.8,217,895.8,216.9,895.8,216.8z M896.8,211.1
		c-0.1-3.2-1.6-4.6-4.6-4.7c-3.3-0.1-4.4,2-5.1,4.7C890.4,211.1,893.5,211.1,896.8,211.1z"
      />
      <path
        class="st0"
        d="M430,217c2.7,5.3,6.7,6.6,12.7,4.7c1.2-0.4,2.7-1.9,2.9,0.4c0.1,1.6,1.4,4-1.2,5.2c-5,2.5-16.4,1.5-19.7-2.3
		c-4.7-5.3-4.4-11.6-2.2-17.8c2-5.5,11.1-9.6,16.6-7.7c6.3,2.2,10.5,9.9,8.9,16c-0.5,1.9-2,1.4-3.2,1.5C440.1,217,435.3,217,430,217
		z M439.8,211.1c0.1-3.3-1.5-4.7-4.5-4.8c-3.3-0.1-4.5,1.9-5.1,4.8C433.3,211.1,436.3,211.1,439.8,211.1z"
      />
      <path
        class="st0"
        d="M580,220.6c0.6,7.1,0.3,7.3-6.2,7.9c-13.7,1.1-22-8.3-17.3-19.8c2.6-6.4,10.2-10.8,16.3-9.3
		c6.6,1.5,10.3,7.1,10.1,14.6c-0.1,2.4-0.8,3.2-3.1,3.1c-4-0.2-8-0.1-12-0.1c-0.9,0-2.2-0.5-2.7,0.6c-0.6,1.3,0.7,2.3,1.4,2.8
		C570.8,223.5,575.3,222.6,580,220.6z M564.2,211.2c2.8,0,5.1,0,7.4,0c0.3,0,0.7,0,1,0c2.8,0.1,2.6-1.3,1.4-3
		C571.7,204.9,567.8,205.9,564.2,211.2z"
      />
      <path
        class="st0"
        d="M663.1,207.4c-2.9-1-5.8-1.2-8.8-1.1c-1.1,0.1-2.2,0.2-2.4,1.3c-0.3,1.3,0.6,2.1,1.9,2.5c2,0.7,4.2,1.1,6,2.1
		c3.2,1.7,5.6,4,5.1,8.2c-0.5,3.8-2.8,5.6-6.1,6.9c-2.6,1-5.1,1.3-7.8,1.2c-7.9,0-8.9-1-8.3-9.3c3.5,0.7,6.3,3.8,10.3,2.9
		c1.4-0.3,2.9-0.5,3.2-1.8c0.5-1.7-1.3-1.9-2.5-2.3c-1.6-0.5-3.1-1.1-4.6-1.7c-4.1-1.8-7.3-4.7-6.3-9.4c1.1-4.9,5.3-6.9,10-7.8
		c0.8-0.2,1.7,0,2.5,0C663,199.2,663.2,199.4,663.1,207.4z"
      />
      <path
        class="st0"
        d="M1140.5,206.8c-1.3-1.4-4.7,1.2-4.3-2.5c0.2-2-1.7-5.5,3-5.1c0.6,0.1,1.1-0.1,1.4-0.9c2.6-6.6,2.6-6.6,9.4-7.8
		c0,1.7,0.1,3.3,0,4.9c-0.3,2.8,0.3,4.4,3.6,3.8c3.4-0.6,2.5,2,2.7,3.9c0.2,2.1,0.1,3.8-2.7,3.2c-3.6-0.7-4,1.3-3.7,4.2
		c0.2,2.5-0.2,5,0.3,7.5c0.6,3.3,2,5.8,6.4,3c-0.7,3,1.6,6.5-3.1,7.5c-5.1,1.1-10.2-0.8-11.7-4.9
		C1139.5,218.1,1140.6,212.5,1140.5,206.8z"
      />
      <path
        class="st0"
        d="M501,221.5c0.1,3.4,1,6.6-3.6,7c-6,0.6-9.9-1.1-11.3-5.7c-1.3-4.4-0.3-8.9-0.7-13.4c-0.1-1.1,0.7-3.2-1.4-3
		c-3.2,0.3-2.9-1.5-3-3.6c-0.1-2.3,0.1-3.9,3-3.7c1.9,0.2,1.3-1.5,1.4-2.5c0.4-3.4,5.4-7.3,8.3-6.3c1.9,0.6,0.8,2.3,0.8,3.4
		c0.1,3-0.7,6.3,4.4,5.5c3.1-0.5,1.8,2.4,2.1,3.9c0.2,1.7,0.3,3.6-2.4,3.1c-4.2-0.9-4.5,1.5-4.1,4.7c0.2,2,0,4,0.1,6
		C494.8,221.5,496.2,222.5,501,221.5z"
      />
      <path
        class="st0"
        d="M1002.4,214.7c0-2,0-4,0-6c0-1.2,0-2.6-1.7-2.3c-2.9,0.4-3-1.2-3.1-3.5c0-2.3,0-3.9,3-3.6
		c2.1,0.2,1.6-1.5,1.7-2.8c0.2-3.2,4.5-6.8,7.7-6.1c2.6,0.6,0.9,2.8,1,4.2c0.2,2.8-0.6,5.6,4.1,4.8c3.4-0.5,1.8,2.7,2.2,4.3
		c0.6,2.4-0.8,3-2.7,2.7c-3.1-0.5-4.1,0.7-3.7,3.8c0.3,2.6-0.1,5.3,0.2,8c0.2,1.9,0.5,4,3.3,4.1c1.1,0,3.2-2.2,3.1,1.2
		c-0.1,2.1,0.3,4.2-2.6,5c-6.7,2-12.4-1.9-12.6-8.8C1002.3,218,1002.4,216.3,1002.4,214.7z"
      />
      <path
        class="st0"
        d="M624.4,214.8c0-2,0-4,0-6c0-1.1,0.2-2.7-1.6-2.4c-3.3,0.5-2.8-1.6-2.9-3.6c-0.2-2.4,0.2-3.9,3.1-3.6
		c1.4,0.1,1.5-1.1,1.4-2c-0.9-5.9,4.3-5.4,7.4-6.6c2.3-0.9,1.4,1.5,1.4,2.6c0.1,3.3-1.1,7.1,4.9,6.3c2.9-0.4,1.4,2.7,1.7,4.2
		c0.4,1.7-0.1,3.1-2.3,2.7c-4.6-0.9-4.6,1.9-4.4,5.1c0.2,2.2,0,4.3,0.1,6.5c0.1,2.2,1,4.2,3.3,4.2c1.9,0,3.6-1.5,3.4,2.2
		c-0.1,3.1-1.5,4-4.1,4.4c-7.5,1-11.4-2.3-11.5-9.8C624.4,217.5,624.4,216.1,624.4,214.8z"
      />
      <path
        class="st0"
        d="M410,202.9c1-0.8,1.7-1.3,2.2-1.9c1.6-1.9,3.9-2.7,5.7-1.5c1.9,1.3,0.7,4,0.8,6.1c0.1,3-2.3,1.5-3.6,1.6
		c-3.1,0.3-4.6,2.1-5.3,5c-1.1,4.4-0.5,8.9-0.3,13.4c0.2,4.7-3.1,2.6-5.1,2.9c-2.1,0.4-4.1,0.7-4-3c0.3-7,0-14,0.1-20.9
		c0-1.8-1.9-5,1.6-5.2C405,199.2,409.2,197.1,410,202.9z"
      />
      <path
        class="st0"
        d="M1169.7,214.3c0,3-0.4,6,0.1,9c0.8,4.8-1.1,5.8-5.5,5.5c-2.8-0.2-3.7-0.6-3.7-3.6c0.2-7.5,0.2-15-0.1-22.4
		c-0.2-3.6,1.5-3.8,4.2-3.6c2.5,0.2,5.6-0.9,5.1,3.7C1169.4,206.7,1169.7,210.5,1169.7,214.3z"
      />
      <path
        class="st0"
        d="M195.4,214.5c0,3.3-0.4,6.7,0.1,9.9c0.6,4.4-1.8,4.1-4.9,4.3c-3.6,0.2-4.6-0.8-4.4-4.3
		c0.3-7.1,0.3-14.3,0-21.4c-0.2-4.4,2.4-3.8,5-3.9c2.8-0.1,4.8,0.1,4.4,3.9C195.1,206.9,195.4,210.7,195.4,214.5
		C195.4,214.5,195.4,214.5,195.4,214.5z"
      />
      <path
        class="st0"
        d="M1164.6,195.7c-2.8-0.6-4.8-2.1-4.3-5.4c0.5-3.2,2.8-4.4,5.8-4c3,0.4,5,2.3,4.5,5.3
		C1170.2,194.8,1167.7,195.7,1164.6,195.7z"
      />
      <path
        class="st0"
        d="M195.9,192.7c-0.5,2.4-2.9,3.1-5.7,2.8c-2.6-0.4-5-1.6-4.5-4.7c0.5-3.2,2.7-4.9,6-4.4
		C194.7,186.7,196.3,188.4,195.9,192.7z"
      />
    </g>
  </svg>`,
  standalone: true,
})
export class NavLogoComponent {}
